<template>
  <NavbarFive class="home_one" />
  <ResponsiveNavbarFive class="home_one" />
  <PageBanner pageTitle="About Us" mainTitle="About Us" />
  <WhyChoiceForYou />
  <BrandLogo class="pb-100" />
  <WorldwideUserManagementApp />
  <HowItWorks />
  <OurCustomerReviews class="pb-100" />
  <OurLatestBlog />
  <DownloadTheApp />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarFive from "../components/Layouts/NavbarFive.vue";
import ResponsiveNavbarFive from "../components/Layouts/ResponsiveNavbarFive.vue";
import PageBanner from "../components/Common/PageBanner.vue";
import WhyChoiceForYou from "../components/AboutUs/WhyChoiceForYou.vue";
import BrandLogo from "../components/Common/BrandLogo.vue";
import WorldwideUserManagementApp from "../components/AboutUs/WorldwideUserManagementApp.vue";
import HowItWorks from "../components/AboutUs/HowItWorks.vue";
import OurCustomerReviews from "../components/Common/OurCustomerReviews.vue";
import OurLatestBlog from "../components/AboutUs/OurLatestBlog.vue";
import DownloadTheApp from "../components/Common/DownloadTheApp.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "AboutUsPage",
  components: {
    NavbarFive,
    ResponsiveNavbarFive,
    PageBanner,
    WhyChoiceForYou,
    BrandLogo,
    WorldwideUserManagementApp,
    HowItWorks,
    OurCustomerReviews,
    OurLatestBlog,
    DownloadTheApp,
    MainFooter,
  },
});
</script>